import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "lightbulb",
  "use": "lightbulb-usage",
  "viewBox": "0 0 29 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 40\" id=\"lightbulb\"><path d=\"M21.422 31.667c.524-3.154 1.851-6.134 3.786-8.734A13.24 13.24 0 0027.833 15c0-7.865-6.81-14.14-14.856-13.248C7.114 2.4 2.24 7.037 1.332 12.863c-.58 3.734.394 7.229 2.37 9.949 1.935 2.66 3.317 5.665 3.865 8.855m13.854 0a18.102 18.102 0 00-.256 2.995V35a3.333 3.333 0 01-3.333 3.333h-6.666A3.333 3.333 0 017.832 35v-.332c0-1.016-.096-2.016-.265-3.001m13.854 0H7.568\" stroke=\"currentColor\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/lightbulb.svg
// module id = QREM
// module chunks = 38 43